import { Maybe, ReportOutputType, ReportTemplateFormat } from '../graphql/schema/p4types';

export const getDefaultOutputType = (
  format?: Maybe<ReportTemplateFormat>
): { value: ReportOutputType; label: string } => {
  if (format === ReportTemplateFormat.Handlebars) {
    return {
      value: ReportOutputType.Email,
      label: 'E-Mail',
    };
  }

  return {
    value: ReportOutputType.LocalPrinter,
    label: 'Local Printer',
  };
};
